import {
  IPeerGroupsProps,
  IFilter,  getPerformanceTrendData, getPeerGroupData
} from "app/components/visualizations/PeerGroups/lib/http";
import * as React from "react";
import { Row, Col, Panel } from "react-bootstrap";
import { TabHeader } from "app/components/tabs/header";
import { PeerGroupTrend } from "app/components/visualizations/PeerGroups/Performance/PeerGroupTrend";
import { PeerGroupTable } from "app/components/visualizations/PeerGroups/Performance/PeerGroupTable";
import { StarRatings } from "app/components/visualizations/PeerGroups/Performance/StarRatings";
import { PeerGroupYearOverYear } from "app/components/visualizations/PeerGroups/Performance/PeerGroupYearOverYear";
import { PeerGroupYearOverYearTable } from "app/components/visualizations/PeerGroups/Performance/PeerGroupYearOverYearTable";
import { SubHeader } from "app/components/tabs/SubHeader";

export interface IOtherState {
  data: any[];
  currentPeerGroup: any[];
  filters: IFilter;
}

export class Performance extends React.Component<
  IPeerGroupsProps,
  IOtherState
> {
  state: IOtherState = {
    data: [],
    currentPeerGroup: [],
    filters: { assetLevel: 0 },
  };

  componentDidMount() {
    this.pullData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData();
      });
    }
  }

  pullData() {
    const performanceRequestTab = {
      action: "getPerformanceTab",
      request: { assetLevel: this.props.filters.assetLevel },
    };
    getPeerGroupData(performanceRequestTab).then((response: any[]) => {
      const currentPeerGroup = response.find(
        (dataPoint, index) =>
          dataPoint.filterId === this.props.filters.assetLevel
      );
      
      this.setState({ data: response, currentPeerGroup });
    });
  }

  render() {
    const { assetLevel, assetName } = this.props.filters;
    const { currentPeerGroup, data } = this.state
    return (
      <>
        <TabHeader filters={{ assetLevel, assetName }} label="Performance" />
        <Row>
          <Col sm={12} md={6} className="text-center fontSize1_7" style={{ padding: '20px 35px'}}>
            {currentPeerGroup && currentPeerGroup['InvPer_T_B_PerfIntro']}
          </Col>
          <Col sm={12} md={6} className="text-center fontSize1_7" style={{ padding: '20px 35px'}}>
            {currentPeerGroup && currentPeerGroup['InvPer_T_B_PerfText4']}
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <PeerGroupTrend filters={{ assetLevel, assetName }} data={[]} />
          </Col>
         
        </Row>
        <Row>
          <Col sm={12} md={4} className="text-center fontSize1_7" style={{ padding: '20px 35px'}}>
            {currentPeerGroup && currentPeerGroup['InvPer_T_B_PerfText1']}
          </Col>
          <Col sm={12} md={8}>
            <PeerGroupTable filters={{ assetLevel, assetName }} data={[]} />
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="text-center fontSize1_7" style={{ padding: '20px 35px'}}>
            {currentPeerGroup && currentPeerGroup['InvPer_T_B_PerfText2']}
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <PeerGroupYearOverYear filters={{ assetLevel, assetName }} data={[]} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <PeerGroupYearOverYearTable filters={{ assetLevel, assetName }} data={[]} />
          </Col>
        </Row>
        <SubHeader label="Star Ratings" />
        <Row>
          <Col sm={12} md={4} style={{ padding: '10px 20px'}}>
            <p style={{ padding: '10px 20px'}}>{currentPeerGroup && currentPeerGroup['InvPer_T_B_StarText1']}</p>
            <p style={{ padding: '10px 20px'}}>{currentPeerGroup && currentPeerGroup['InvPer_T_B_StarText2']}</p>
          </Col>
          <Col sm={12} md={8}>
            <StarRatings filters={{ assetName, assetLevel}} data={data} />
          </Col>
        </Row>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/Performance.tsx